module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAIAAACQd1PeAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAAMSURBVBhXY/j//z8ABf4C/qc1gYQAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// /builds/applied-technologies/apt-lab/digitalbank-frontend-projects/digitalbank-web/src/styles/storymap/images/layers.png
// module id = ../../../../../src/styles/storymap/images/layers.png
// module chunks = styles